import { render, staticRenderFns } from "./ViewRegistration.vue?vue&type=template&id=2bd1b763&scoped=true"
import script from "./ViewRegistration.vue?vue&type=script&lang=js"
export * from "./ViewRegistration.vue?vue&type=script&lang=js"
import style0 from "./ViewRegistration.vue?vue&type=style&index=0&id=2bd1b763&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd1b763",
  null
  
)

export default component.exports